import styles from "./loading.module.css";

export default function Loading() {
  return <span className={styles.loader}></span>;
}
